import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, takeWhile, tap } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import * as fromSettings from './company-setting';
import { LoggingService } from './shared/services/logging';
import * as fromUser from './user-info';
import * as fromRoot from './store';
@Component({
    selector: 'app-footer',
    templateUrl: './app.footer.component.html',
    styleUrls: ['./app.footer.component.scss'],
    standalone: false
})
export class AppFooterComponent implements AfterViewInit, OnDestroy {
    public environment = environment;
    public ShowBetaMessage = true;
    public version$: Observable<string>;
    private userInfo$: Observable<fromUser.IUserInfo>;
    private active = true;
    adminFooterMessage$: Observable<string>;
    adminFooterLink$: Observable<string>;
    constructor(
        private store: Store,
        public app: AppComponent,
        private log: LoggingService
    ) {
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
    }
    ngAfterViewInit(): void {
        this.version$ = this.store.pipe(select(fromRoot.Version.selectVersion));
        this.userInfo$
            .pipe(
                takeWhile(() => this.active)
                // distinctUntilChanged()
            )
            .subscribe(userInfo => {
                this.ShowBetaMessage = userInfo.ShowBetaMessage === true;
            });
        this.adminFooterMessage$ = this.store.pipe(
            select(fromSettings.getSettingValue('AdminFooterMsg1')),
            filter(x => !!x),
            tap(setting =>
                this.log.verbose({
                    type: 'AppFooterComponent:adminFooterMessage$',
                    setting
                })
            )
        );
        this.adminFooterLink$ = this.store.pipe(
            select(fromSettings.getSettingValue('AdminFooterLink1')),
            filter(x => !!x),
            tap(setting =>
                this.log.verbose({
                    type: 'AppFooterComponent:adminFooterLink$',
                    setting
                })
            )
        );
    }
    ngOnDestroy(): void {
        this.active = false;
    }
}
